module.exports = __webpack_public_path__ + "img/topsx_bg.a556834e.png";